import {Pipe, PipeTransform} from '@angular/core';
import {MonthlyAllowanceClaimList} from '../dto/user-allowance/monthly-allowance-claim-list';
import {DmsSalesReturnList} from '../dto/dms-sales-return-list';

@Pipe({name: 'selected', pure: true})
export class SelectedCheckPipe implements PipeTransform {

    transform<T>(data: T[], map: any, type: string = 'all'): boolean {
        if (!data || data.length === 0 || !map)  {
            return false;
        }
        
        const selectableDataLength = data.length;
        let selectedDataLength = 0;
        
        for (let i = 0;  i < data.length; i++) {
            const item: any = data[i];
            const id = item && item.id != null ? item.id : (item && item.Id != null ? item.Id : null);
            if (map.has(id)) {
                selectedDataLength++;
            }
        }
        
        if (type === 'all') {
            return selectableDataLength > 0 && selectableDataLength === selectedDataLength;
        } else if (type === 'indeterminate') {
            return selectedDataLength > 0 && selectedDataLength < selectableDataLength;
        }
        
        return false;
    }
}

@Pipe({name: 'selectedSalesReturn', pure: true})
export class SelectedSalesReturnCheckPipe implements PipeTransform {

    transform(data: DmsSalesReturnList[], map: any, type: string): boolean {
        if (data.length === 0)  {
            return false;
        }

        const selectableDataLength = data.length;
        let selectedDataLength = 0;

        for (let i = 0;  i < data.length; i++) {
            if (map.has(data[i].id)) {
                selectedDataLength++;
            }
        }

        if (type === 'all') {
            return selectableDataLength > 0 && selectableDataLength === selectedDataLength;
        } else if (type === 'indeterminate') {
            return selectedDataLength > 0 && selectedDataLength < selectableDataLength;
        }

        return false;
    }
}
